import classNames from 'classnames';
import styles from '@/modules/entity/components/verificationLoadingScreen.module.css';

export const VerificationLoadingScreen = ({ className }: { className?: string }) => {
  return (
    <div
      className={classNames(
        'w-full sm:h-full flex flex-col items-center justify-center gap-10 m-0',
        className,
      )}
    >
      <svg width="112" height="128">
        <g stroke="#0EA5E9" width="112px" height="128" strokeWidth="1">
          <path
            className={styles.verifyingAnimation}
            d="M55.9998 0l.0004.0002L56.0007 0 112 31.9999V95.9996L100.801 102.4v-.001h-.002V38.4991L56.0002 12.8998 11.2008 38.4995V89.5001l-.0008.0005V102.4L0 95.9996V31.9999L55.9998 0Z"
          />
          <path
            className={styles.verifyingAnimation}
            d="M67.2009 121.6V73.6003l-11.2 6.4V128l11.2-6.4Z"
          />
          <path
            className={styles.verifyingAnimation}
            d="M89.5993 52.8021l-11.2 6.4V115.202l11.2-6.4V52.8021Z"
          />
        </g>
      </svg>
      <div className="w-full flex items-end justify-center">
        <p className="text-[48px] leading-[56px] font-serif text-center">Verifying, please wait</p>
        <div id="wave">
          <span className="dot"></span>
          <span className="dot"></span>
          <span className="dot"></span>
        </div>
      </div>
    </div>
  );
};
